import { useEffect, useState } from "react";
import AvailableTime from "../../components/helpers/availableTime";
import {
  getInReviewProviders,
  getPendingIDCheck,
  getProviders,
} from "../../utils/apis/func";
import { useAppSelector } from "../../utils/redux/hooks";
import PendingIDCheck from "./PendingIDCheck";
import {Link} from 'react-router-dom';
import DeclinedIDCheck from "./DeclinedIDCheck";
import axios from "axios";

interface TabItem {
  label: string;
  count: number | null;
}

const IDCheck = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [tabItems, setTabItems] = useState<TabItem[]>([]);


const fetchVerifications = async (endpoint: string) => {
  const AuthToken = await localStorage.getItem("AuthToken");
  try {
    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });

    const { data } = response.data;
    return data || {}; 
  } catch (error) {
    console.error("Error fetching Verification Requests:", error);
    return {};
  }
};

const fetchTabData = async () => {
  const verificationsInReview = await fetchVerifications(
    "https://api.pureworker.com/api/admin/pending-verifications?status=pending"
  );
  const rejectedVerifications = await fetchVerifications(
    "https://api.pureworker.com/api/admin/pending-verifications?status=rejected"
  );
  
  let tabItems: TabItem[] = [
    { label: "Pending", count: verificationsInReview?.totalRecords ?? null },
    { label: "Declined", count: rejectedVerifications?.totalRecords ?? null },
  ];

  return tabItems;
};


  useEffect(() => {
    const loadTabData = async () => {
      const tabItemsData = await fetchTabData();
      setTabItems(tabItemsData);
    };

    loadTabData();
  }, []);
  
  return (
    <div className="">
      <div className="px-3">
        <p className="text-[#000] font-roboto text-2xl font-medium leading-normal mt-4 border-b-2 border-[#000] w-fit px-4">
          ID Check
        </p>
      </div>
      <p className="px-6 mt-4">Review submitted identity checks here. <Link className="text-purple-800 underline" to="/verified-providers">View Verified SPs and both approval statuses</Link></p>
      <section className="flex px-2 lg:px-8 mt-6 mb-2 gap-4 lg:gap-6">
        {tabItems.map((tab, index) => (
          <p
            key={index}
            className={`bg-[#fff] py-2 px-2 lg:px-6 rounded-full text-center font-outfit text-xs lg:text-sm font-medium leading-normal tracking-tighter cursor-pointer border ${
              selectedTab === index ? "border-[#88087B]" : ""
            }`}
            onClick={() => setSelectedTab(index)}
          >
            {tab.label}{" "}
            {tab.count !== null && (
              <span className="bg-[#88087B] rounded-sm text-[#fff] px-1 ml-0.5 lg:ml-2">
                {tab.count}
              </span>
            )}
          </p>
        ))}
      </section>
      <main className="px-4">
        {selectedTab === 0 && <PendingIDCheck />}
        {selectedTab === 1 && <DeclinedIDCheck />}
      </main>
    </div>
  );
};

export default IDCheck;
